import React, { useState, useEffect } from "react";
import { Box, Typography, LinearProgress, Divider } from "@mui/material";

export const resumeMeta = {
  hasPhoto: false,
  columns: 1,
};

const Resume29 = ({
  theme = "#333333", // Dark theme for the contact bar
  color,
  font = "Arial",
  fontSize = "13px",
  headingSize = "16px",
  sectionSpacing = 24,
  paragraphSpacing = 8,
  lineSpacing = 18,
  topBottomMargin = 40,
  sideMargins = 50,
  pageSize = "A4",
}) => {
  const [themeColor, setThemeColor] = useState(color || theme);

  useEffect(() => {
    setThemeColor(color || theme);
  }, [color, theme]);

  const getPageWidth = () => (pageSize === "A3" ? "297mm" : "210mm");
  const getPageHeight = () => (pageSize === "A3" ? "420mm" : "297mm");

  const sectionTitleStyle = {
    fontWeight: "bold",
    fontSize: headingSize,
    textTransform: "uppercase",
    letterSpacing: "1px",
    mt: `${sectionSpacing}px`,
    mb: `${paragraphSpacing}px`,
    color: "#000",
  };

  return (
    <Box sx={{ bgcolor: "#ececec",  }}>
      <Box
        sx={{
          width: getPageWidth(),
          minHeight: getPageHeight(),
          bgcolor: "#fff",
          mx: "auto",
          fontFamily: font,
          fontSize: fontSize,
          lineHeight: `${lineSpacing}px`,
          boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          position: "relative",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Top Header - Name only */}
        <Box sx={{ px: `${sideMargins}px`, pt: `${topBottomMargin}px`, pb: 2 }}>
          <Typography variant="h4" sx={{ fontWeight: 700, color: "#333", letterSpacing: "2px" }}>
            MATTHEW ELIOT
          </Typography>
        </Box>

        {/* Contact Info Bar */}
        <Box
          sx={{
            bgcolor: themeColor,
            color: "#fff",
            display: "flex",
            justifyContent: "space-between",
            px: `${sideMargins}px`,
            py: 1.5,
            mb: 2,
          }}
        >
          <Typography variant="caption">📧 matthew.eliot@mail.com</Typography>
          <Typography variant="caption">📞 +1 (970) 333-3833</Typography>
          <Typography variant="caption">📍 New York, NY 10001</Typography>
        </Box>

        {/* Content Area */}
        <Box sx={{ px: `${sideMargins}px`, pb: `${topBottomMargin}px` }}>
          {/* Summary */}
          <Box>
            <Typography sx={sectionTitleStyle}>Summary</Typography>
            <Typography variant="body2" sx={{ textAlign: "justify" }}>
              Senior Web Developer specializing in front end development. Experienced with all stages of the development cycle for dynamic web projects. Well-versed in numerous programming languages including HTML5, PHP OOP, JavaScript, CSS, MySQL.
            </Typography>
          </Box>

          {/* Skills - 2 Column Grid */}
          <Box>
            <Typography sx={sectionTitleStyle}>Skills</Typography>
            <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "4px 20px" }}>
              {["Project management", "Creative design", "Complex problem solver", "Service-focused", "Innovative", "Team Leadership"].map((skill) => (
                <Typography key={skill} variant="body2" sx={{ display: "flex", alignItems: "center" }}>
                  <span style={{ fontSize: "14px", marginRight: "8px" }}>•</span> {skill}
                </Typography>
              ))}
            </Box>
          </Box>

          {/* Experience - Split Layout */}
          <Box>
            <Typography sx={sectionTitleStyle}>Experience</Typography>
            
            <Box sx={{ display: "flex", mt: 2, mb: 3 }}>
              <Typography sx={{ width: "130px", flexShrink: 0, color: "#777", fontWeight: "bold" }}>
                09/2015 - Present
              </Typography>
              <Box>
                <Typography fontWeight="bold" sx={{ fontSize: "14px" }}>Web Developer</Typography>
                <Typography variant="body2" sx={{ fontStyle: "italic", color: "#555" }}>Luna Web Design, New York</Typography>
                <ul style={{ paddingLeft: "16px", marginTop: "8px" }}>
                  <li>Cooperate with designers to create clean interfaces and simple, intuitive experiences.</li>
                  <li>Complete detailed programming and development tasks for front end public websites.</li>
                </ul>
              </Box>
            </Box>
          </Box>

          {/* Education */}
          <Box>
            <Typography sx={sectionTitleStyle}>Education</Typography>
            <Box sx={{ display: "flex", mt: 1 }}>
              <Typography sx={{ width: "130px", flexShrink: 0, color: "#777", fontWeight: "bold" }}>2014</Typography>
              <Box>
                <Typography fontWeight="bold">Bachelor of Science: Computer Information Systems</Typography>
                <Typography variant="body2">Columbia University, NY</Typography>
              </Box>
            </Box>
          </Box>

          {/* Languages - Progress Bars */}
          <Box sx={{ mt: 4 }}>
            <Typography sx={sectionTitleStyle}>Languages</Typography>
            <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px 50px" }}>
              <Box>
                <Typography variant="caption" sx={{ display: "block", mb: 0.5, fontWeight: "bold" }}>English (Native)</Typography>
                <LinearProgress 
                  variant="determinate" 
                  value={100} 
                  sx={{ height: 4, bgcolor: "#eee", "& .MuiLinearProgress-bar": { bgcolor: themeColor } }} 
                />
              </Box>
              <Box>
                <Typography variant="caption" sx={{ display: "block", mb: 0.5, fontWeight: "bold" }}>Spanish (Professional)</Typography>
                <LinearProgress 
                  variant="determinate" 
                  value={75} 
                  sx={{ height: 4, bgcolor: "#eee", "& .MuiLinearProgress-bar": { bgcolor: themeColor } }} 
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Resume29;